package com.evoapps.evoshift.data.remote

/** The Firebase project the clients talk to (matches .firebaserc and functions/index.js). */
object FirebaseProject {
    const val ID = "kreator-grafiku"
    const val FUNCTIONS_REGION = "europe-central2"

    /**
     * The Firebase web client config, used by the web app and the desktop app (SH-97); Android
     * and iOS read theirs from google-services.json / GoogleService-Info.plist. The API key is
     * public by design (restricted in the Google Cloud console; access is governed by
     * firestore.rules) - allowlisted in .gitleaks.toml.
     */
    const val WEB_API_KEY = "AIzaSyDgYbBqDscOSX0S_vyy_3IbDJD51OK6VRE"
    /**
     * The desktop app's own key (SH-184): the web key gets an HTTP-referrer restriction, which a
     * desktop app cannot satisfy. Same service restrictions, public like the others.
     */
    const val DESKTOP_API_KEY = "AIzaSyBrcWoJhxCwDNLv-lV8ighdY1GE8MjhYAw"
    const val WEB_APP_ID = "1:781672312389:web:c904a261add18c6efb7d2c"
    /**
     * The shared EVoApps sign-in domain (Hosting site `getevoapps`): serves Firebase Auth's
     * `/__/auth/handler` for Google / Apple pop-ups, so they name login.getevoapps.app instead of
     * the project's firebaseapp.com. Same project; only the handler's host changes.
     */
    const val AUTH_DOMAIN = "login.getevoapps.app"
    const val DATABASE_URL = "https://$ID-default-rtdb.europe-west1.firebasedatabase.app"
    const val STORAGE_BUCKET = "$ID.firebasestorage.app"

    /** A `demo-` project: the emulators never reach a real project under this id. */
    const val EMULATOR_ID = "demo-evoshift"

    /**
     * Base URL of the callable functions. Local development against the emulators points it at
     * the Functions emulator before the app starts (web: `?emulator`, see jsMain/main.kt).
     */
    var functionsBaseUrl: String = CloudFunctionsClient.baseUrl(ID, FUNCTIONS_REGION)

    fun useFunctionsEmulator(host: String, port: Int, projectId: String = EMULATOR_ID) {
        functionsBaseUrl = "http://$host:$port/$projectId/$FUNCTIONS_REGION"
    }

    /** Firebase Storage's REST API (profile photos, SH-94); the emulator's in local development. */
    var storageBaseUrl: String = FirebaseStorageClient.PRODUCTION_BASE_URL

    /** The default bucket (as in the web app's Firebase options and functions/index.js). */
    var storageBucket: String = STORAGE_BUCKET

    fun useStorageEmulator(host: String, port: Int, projectId: String = EMULATOR_ID) {
        storageBaseUrl = "http://$host:$port"
        storageBucket = "$projectId.appspot.com"
    }
}
